import { useQuery } from 'react-query';
import { FarmerProfileService } from '~/api/services/farmerProfile';
import { FarmersService } from '~/api/services/farmers/index';
import { MGAAttachmentService } from '~/api/services/mgaAttachments';
import { onError } from '~/utils/helpers';

const getFarmersList = (data?) => useQuery(
  'farmers-list',
  () => FarmersService.getFarmersList(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmersListOptions = () => useQuery(
  'farmers-list-options',
  FarmersService.getFarmersListOptions,
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmersQueryCount = (data?) => useQuery(
  'farmers-count',
  () => FarmersService.getFarmersCount(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerSubFarmers = (data?) => useQuery(
  'subfarmer-count',
  () => FarmerProfileService.getSubFarmersData(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getEmailsOptions = (id) => useQuery(
  'farmers-emails-options',
  () => FarmersService.getEmailsOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getEmailsList = (id, data?) => useQuery(
  `farmers-emails-list-${data.search}`,
  () => FarmersService.getEmails(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getProfileData = () => useQuery(
  'farmers-profile-data',
  () => FarmerProfileService.getProfileData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerProfileFile = (id) => useQuery(
  'farmers-profile-file-data',
  () => FarmersService.getFarmerFile(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerFinancialDataQuery = (id) => useQuery(
  'farmers-financial-data',
  () => FarmersService.getFarmerFinancialData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerMgaAttachments = (id, data) => useQuery(
  'farmers-mga-attachments',
  () => MGAAttachmentService.getAllMgaAttachments(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmersActivityLogs = (id, data) => useQuery(
  `farmers-activity-logs-${data.search}`,
  () => FarmersService.getFarmersActivityLogs(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMgaFactors = (id) => useQuery(
  'farmers-mga-factors',
  () => FarmersService.getMgaFactors(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMgaFactorsOptions = (id) => useQuery(
  'farmers-mga-factors-options',
  () => FarmersService.getMgaFactorsOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getTaxOptions = (id) => useQuery(
  'farmers-show-taxaxation-options',
  () => FarmersService.getTaxationOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getTaxData = (id) => useQuery(
  'farmers-show-tax-data',
  () => FarmersService.getTaxData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFinancialData = (onError, id) => useQuery(
  'farmers-show-financial-data',
  () => FarmersService.getFinancialFarmerData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFormHusbandryOptions = (id) => useQuery(
  'farmers-form-husbandry-options',
  () => FarmersService.getFormHusbandryOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFormHusbandry = (id) => useQuery(
  'farmers-form-husbandry-get',
  () => FarmersService.getFormHusbandry(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getSmsLogs = (id, data) => useQuery(
  'farmers-sms-logs',
  () => FarmersService.getSmsLogs(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getSmsLogsOptions = (id, data) => useQuery(
  'farmers-sms-logs-options',
  () => FarmersService.getSmsLogsOptions(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getArticles = (id, data) => useQuery(
  `farmers-articles-get-${data.search}`,
  () => FarmersService.getArticles(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerArticleBookings = (idFarmer: string, idArticle: string, data?) => useQuery(
  'farmers-article-bookings-list',
  () => FarmersService.getFarmerArticleBookings(idFarmer, idArticle, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getShowFarmerUsersData = (data) => useQuery(
  'farmers-users-get',
  () => FarmersService.getShowFarmerUsersData(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const countFarmerUsers = (data) => useQuery(
  'farmers-users-count',
  () => FarmersService.countFarmerUsers(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getShowFarmerUsersOptions = () => useQuery(
  'farmers-users-get-options',
  FarmersService.getShowFarmerUsersOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerProfileData = (id) => useQuery(
  'farmers-profile-data',
  () => FarmersService.getFarmerProfileData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getTradingMonths = (id, prefix, data) => useQuery(
  `farmers-${prefix}-trading-months-data`,
  () => FarmersService.getTradingMonths(id, prefix, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getArticleList = () => useQuery(
  'farmers-article-list',
  FarmersService.getArticleList,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getBookings = (id, idArticle, enable = false) => useQuery(
  'farmers-bookings-list',
  () => enable && FarmersService.getBookings(id, idArticle),
  {
    enabled: enable,
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const bookingHistoryList = (id, data, enabled = false) => useQuery(
  'farmers-bookings-history-list',
  () => enabled && FarmersService.bookingHistoryList(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const bookingHistorySettings = (id) => useQuery(
  'farmers-bookings-history-settings',
  () => FarmersService.bookingHistorySettings(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const tradingActivitiesFarmer = (id, prefix, data) => useQuery(
  `farmers-${prefix}-trading-activities-list`,
  () => FarmersService.getTradingActivitiesFarmer(id, prefix, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDairyOptions = (id, prefix) => useQuery(
  'farmers-dairy-options',
  () => FarmersService.getDairyOptions(id, prefix),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDairyData = (id, data, prefix) => useQuery(
  `farmers-dairy-data-${data.year}`,
  () => FarmersService.getDairyData(id, data, prefix),
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getStates = (countryId) => useQuery(
  'farmers-get-states-data',
  () => countryId && FarmersService.getStates({ countryId }),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getZipDistrictState = (zip, zipFieldTouched) => useQuery(
  `farmers-get-${zip}-states-data`,
  () => zipFieldTouched && FarmersService.getZipDistrictState({ zip }),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getFarmerDetails = (id) => useQuery(
  'farmers-dairy-details',
  () => FarmersService.getFarmerDetails(id),
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerOptions = () => useQuery(
  'farmers-dairy-show-options',
  FarmersService.getFarmerOptions,
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerContacts = (id, data) => useQuery(
  'farmers-dairy-contacts',
  () => FarmersService.getContacts(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerNotes = (id, data) => useQuery(
  'farmers-dairy-notes',
  () => FarmersService.getNotes(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerNotesOptions = (id) => useQuery(
  'farmers-dairy-notes-options',
  () => FarmersService.getNotesOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerMilkTypeOptions = (id) => useQuery(
  'farmers-dairy-milk-type-options',
  () => FarmersService.getMilkTypesOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerMilkType = (id) => useQuery(
  'farmers-dairy-milk-type',
  () => FarmersService.getMilkTypes(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMgaDetails = (id, data) => useQuery(
  'farmers-mga-details',
  () => FarmersService.getMgaDetails(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMgaDetailsData = (id) => useQuery(
  'farmers-mga-details-data',
  () => FarmersService.getMgaData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkSamples = (id, data, enabled = false, prefix) => useQuery(
  `farmers-milk-${prefix}-samples`,
  () => enabled && FarmersService.getMilkSamples(id, data, prefix),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkSamplesData = (id, data) => useQuery(
  'farmers-milk-samples-data',
  () => FarmersService.getMilkSamplesData(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkDeliveries = (id, data, enabled = false) => useQuery(
  'farmers-milk-deliveries',
  () => enabled && FarmersService.getMilkDeliveries(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkDeliveriesData = (id) => useQuery(
  'farmers-milk-deliveries-data',
  () => FarmersService.getMilkDeliveriesData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCO2Footprints = (id, data) => useQuery(
  'farmers-co2-footprints',
  () => FarmersService.getCO2Fooprints(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)
const getClimaFootprints = (id, data) => useQuery(
  'farmers-clima-footprints',
  () => FarmersService.getClimaFootprints(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmers = (data) => useQuery(
  'farmers-list-items',
  () => FarmersService.getFarmers(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getShowFarmerData = (id: string) => useQuery(
  'farmers-show-data',
  () => FarmersService.getShowFarmerData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMonthlyContractAmounts = (id: string, data) => useQuery(
  'farmers-monthly-contract-amounts',
  () => FarmersService.getMontlyContractAmounts(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const FarmersQuery = {
  getFarmersList,
  getFarmersListOptions,
  getFarmersQueryCount,
  getFarmerSubFarmers,
  getEmailsList,
  getEmailsOptions,
  getFarmerProfileFile,
  getProfileData,
  getFarmerMgaAttachments,
  getFarmerFinancialDataQuery,
  getFarmersActivityLogs,
  getMgaFactors,
  getMgaFactorsOptions,
  getFormHusbandry,
  getFormHusbandryOptions,
  getSmsLogs,
  getSmsLogsOptions,
  getArticles,
  getShowFarmerUsersData,
  getShowFarmerUsersOptions,
  getFarmerProfileData,
  getTradingMonths,
  getArticleList,
  getBookings,
  bookingHistoryList,
  bookingHistorySettings,
  getTaxData,
  getTaxOptions,
  getFinancialData,
  tradingActivitiesFarmer,
  getFarmerArticleBookings,
  getStates,
  getZipDistrictState,
  getDairyData,
  getDairyOptions,
  getFarmerDetails,
  getFarmerOptions,
  getFarmerContacts,
  getFarmerNotes,
  getFarmerNotesOptions,
  getFarmerMilkType,
  getFarmerMilkTypeOptions,
  getMgaDetails,
  getMgaDetailsData,
  getMilkSamples,
  getMilkSamplesData,
  getMilkDeliveries,
  getMilkDeliveriesData,
  getCO2Footprints,
  getFarmers,
  getMonthlyContractAmounts,
  getShowFarmerData,
  getClimaFootprints,
  countFarmerUsers
}
